// extracted by mini-css-extract-plugin
module.exports = {"dyplom":"styles_dyplom__1f0VL","logo":"styles_logo__Shu92","button":"styles_button___f1oz","progress":"styles_progress__1RCQ0"};